import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/**
 * Use System.JS to load a registered module.
 * The module is set by sdk.setImportMaps (System.addImportMap) and takes the shape:
 * {
 *   imports: {
 *     [moduleName]: moduleUri
 *   }
 * }
 *
 * @param moduleName
 */
export var remoteImport = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(moduleName) {
    var res;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return System.import(moduleName);
        case 2:
          res = _context.sent;
          return _context.abrupt("return", res);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function remoteImport(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var NO_OP = function NO_OP() {};
export var STABLE_EMPTY_OBJECT = {};